module.exports = __webpack_public_path__ + "img/choose-up-Up Dejun-disabled.32fd7622.png";